<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="微信扫码付款"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <!-- <template #right>
                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>
            </template> -->
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>

        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <!-- 金额 -->
            <van-cell-group>
                <van-field readonly="readonly" v-model="value1" label="￥:" placeholder="00"/>
            </van-cell-group>
            <!-- 数字键盘 -->
            <van-number-keyboard
                    :show="show"
                    theme="custom"
                    extra-key="."
                    v-model="value1"
                    close-button-text="完成"
                    @blur="complete"
                    :maxlength="6"

            />

        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    import {Toast} from 'vant';
    import wx from 'weixin-js-sdk'

    export default {
        name: "TransactionDetails", //扫码收款
        data() {
            return {
                show: true,
                value1: '',


            }
        },
        methods: {
            // 返回上一级
            onClickLeft() {
                // 返回门店首页
                window.history.back();
                // this.$router.push('/StoreHomepage');
            },
            // 右侧icon跳转至商户首页
            // onClickRight() {
            //     // 返回商户首页
            //     this.$router.push('/StoreHomepage');
            // },
            // 选择数字
            onInput(key) {
                this.value1 = (this.value1 + key).slice(0, 6);
            },
            // 删除数字
            onDelete() {
                Toast('删除');
                this.value1 = this.value1.slice(0, this.value1.length - 1);
            },
            //完成输入金额
            complete() {
                let _this =this
                wx.ready(function () {
                    wx.scanQRCode({
                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                        success: function (res) {
                            _this.number = res.resultStr.substring(res.resultStr.indexOf("=")+1);
                            _this.searchResults();
                        }
                    });

                });
            },
            // 调用微信js
            getWechatJs(){
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });

                this.$http.post('/wechat/api.common/getWechatJs',{
                    url:window.location.href.split("#")[0]
                }).then(function(response){
                    Toast.clear();
                    var a=JSON.parse(response.data.data)
                    console.log(a.appId);
                    wx.config({
                        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        debug: false,
                        // 必填，公众号的唯一标识
                        appId: a.appId,
                        // 必填，生成签名的时间戳a
                        timestamp: a.timestamp,
                        // 必填，生成签名的随机串
                        nonceStr: a.nonceStr,
                        // 必填，签名
                        signature: a.signature,
                        // 必填，需要使用的JS接口列表，所有JS接口列表
                        jsApiList: ['checkJsApi', 'scanQRCode']
                    });
                });
                wx.error(function (res) {
                    alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
                });



            },

        },
        created() {
            //初始化微信js
            this.getWechatJs();
        },

      
    }
</script>

<style scoped>

    .van-cell {
        line-height: 1.2rem;
        font-size: 0.9rem;
    }
</style>
<style scoped>
    .van-field__label {
        width: 1.5rem !important;
    }
</style>
